<template>
  <div id="admin_top">
    <div id="newAnnouncements" class="mb-5">
      <h2>最近更新されたお知らせ</h2>
      <ErrorMessage :status="announcementApiStatus.status" :customMessage="announcementApiStatus.customMessage" />

      <AnnouncementList
        v-if="announcementApiStatus.status !== 0"
        :showAll="false"
        :announcementFields="announcementFields"
        @update="updateAnnouncementList"
      >
        <router-link v-if="announcementList.length > 5" to="/admin/Announcements">もっと見る</router-link>
      </AnnouncementList>
    </div>

    <div id="newAchievements">
      <h2>最近登録された成果</h2>
      <ErrorMessage :status="achievementApiStatus.status" :customMessage="achievementApiStatus.customMessage" />

      <AchievementList
        v-if="achievementApiStatus.status === 200"
        :showAll="false"
        :achievements="recentAchievement"
        :achievementTypes="achievementTypes"
        :achievementFields="achievementFields"
        @update="updateAchievementList"
      >
        <router-link v-if="achievementList.length > 5" to="/admin/Achievements">もっと見る</router-link>
      </AchievementList>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import ErrorMessage from '@/components/ErrorMessage.vue'

import AchievementList from '@/components/AchievementList.vue'
import AnnouncementList from '@/components/AnnouncementList.vue'
import { getAnnouncementFieldsForAdmin } from '@/transformer/announcement'
import { getAchievementFieldsForAdmin } from '@/transformer/achievement'

export default {
  name: 'Top',

  components: {
    ErrorMessage,
    AchievementList,
    AnnouncementList
  },

  computed: {
    ...mapState({
      isLoggedIn: (state) => state.auth.isLoggedIn,
      announcementApiStatus: (state) => state.Announcement.listApiStatus,
      achievementTypes: (state) => state.Achievement.achievementTypes,
      achievementApiStatus: (state) => state.Achievement.listApiStatus
    }),
    ...mapGetters('Announcement/', ['announcementList']),
    ...mapGetters('Achievement/', ['achievementList']),
    ...mapGetters('Achievement', ['achievementOptions']),
    recentAchievement: function () {
      let tmparray = this.achievementList
      tmparray.sort(function (a, b) {
        if (a.updated_at > b.updated_at) {
          return -1
        }
        return 1
      })
      if (tmparray.length > 5) {
        tmparray = tmparray.slice(0, 5)
      }
      return tmparray
    },
    announcementFields() {
      return getAnnouncementFieldsForAdmin(false)
    },
    achievementFields() {
      return getAchievementFieldsForAdmin(true, this.achievementOptions)
    }
  },
  methods: {
    updateAchievementList() {
      this.$store.dispatch('Achievement/getAchievementList')
    },
    updateAnnouncementList: function () {
      this.$store.dispatch('Announcement/getAnnouncementList')
    }
  },
  mounted: function () {
    this.updateAchievementList()
    this.updateAnnouncementList()
  }
}
</script>
